/**
 * Header
 * 
 * Description      Controls sticky header
 *
 */
$(function () {
    'use strict';

    if (window.pz === undefined) {
        window.pz = {};
    }

    pz.header = function () {

        var initModule = function () {

            // make header sticky
            var $header = $('.js-page-header'),
                headerHeight, // includes notice, masthead, and primary-nav
                noticeHeight, // notice only
                delta = 5, // delta to trigger scroll event
                lastScrollTop = 0,
                isScroll, // is currently scrolling
                isDown, // is the menu currently down
                isMobile = $(window).width() <= 640 ? true : false, // is it mobile?
                tween; // the tween instance

            /*
                on scroll down from start
                    1. start in natural relative position
                    2. stay relative until scroll up
                on scroll down from below header
                    1. hide header
                on scroll up from below header
                    1. if scroll > bottom of notice, display masthead and primary-nav
                    2. if scroll < bottom of notice, set back to natural relative position (use scroll event for more precision)

                if mobile
                    disable for now - once approved add mobile behaviour

            */

            // On resize event
            $(window).resize(function(event) {
                // is it mobile?
                isMobile = $(window).width() <= 640 ? true : false;
                if (isMobile) {
                    resetNav();
                }
            });

            // On scroll event
            $(window).scroll(function(event){

                isScroll = true;
                headerHeight = $('.js-page-header').outerHeight(); // includes notice, masthead, and primary-nav
                noticeHeight = $('.js-header-notice').outerHeight(); // notice only

                // use more precise scroll calculation than below when in close proximity to top

                // if scroll < notice height OR scroll < header height and not already down, set to natural position (i.e. remove 'fixed')
                if ($(window).scrollTop() < noticeHeight || ($(window).scrollTop() < headerHeight && !isDown )) {
                    resetNav();
                }

            });

            setInterval(function() {
                if (isScroll) {
                    handleScroll();
                    isScroll = false;
                }
                // reset nav if mobile
                if (isMobile) {
                    resetNav();
                }
            }, 250);

            function resetNav() {

                // kill tween
                if (tween)
                    tween.kill();

                // reset header
                $header.css({ 
                    'position': 'relative',
                    'top': '0px' 
                });

                isDown = true;
            }

            function handleScroll() {
                
                if (!isMobile) {
                    var scrollTop = $(window).scrollTop();

                    // check if scrolled more than delta
                    if (Math.abs(lastScrollTop - scrollTop) <= delta)
                        return;

                    // if scrolled down and past the header,  header up
                    if (scrollTop > lastScrollTop && scrollTop > headerHeight) {

                        // if header position is in default state, then hide instantly
                        if ($header.css('position') == 'relative') {
                            $header.css({ 'position':'fixed', 'top':-headerHeight });
                    
                        // otherwise hide using tween
                        } else {
                            tween = TweenLite.to($($header), 0.2, {
                                top: -headerHeight
                            });
                        }

                        isDown = false;

                    // otherwise, header down
                    } else {

                        // if scroll > header, display masthead and primary-nav
                        if (scrollTop > headerHeight) {

                            $header.css({ 'position': 'fixed' });
                            tween = TweenLite.to($($header), 0.2, {
                                top: -noticeHeight
                            });

                            isDown = true;

                        // otherwise display full header
                        } else { 
                            // do nothing - handled in scroll event above
                        }
                    }

                    lastScrollTop = scrollTop;
                }
                
            }

        };

        return {
            initModule: initModule
        };
    }();

    pz.header.initModule();
});